import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.PricingDistributionTemplate.Save.IRequest;
type Response = Api.Core.PricingDistributionTemplate.Save.IResponse;
type Headers = Api.Core.PricingDistributionTemplate.Save.IHeaders;
const url = '/api/ProductManagement/PricingDistributionTemplate';
export default async function pricingDistributionTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
